import { CloseOutlined, PlusCircleFilled } from '@ant-design/icons';
import { useClickOutside } from '@mm/hooks';
import { useAutomationActions } from '@mm/state/actions/automationActions';
import {
  EAutomationAction,
  EAutomationActionCategory,
  IAutomationAction,
} from '@mm/state/model/AutomationModel';
import classNames from 'classnames';
import React from 'react';
import { useAutomationActionList } from '../use-automation-action-list';
import css from './ActionsList.module.css';
import WidgetModel from '@mm/state/model/WidgetModel';

export const ActionsList = (
  props: IAutomationAction & {
    campaignId: number;
    className?: string;
    visibleActionsFilterFunc?: (action: EAutomationAction) => boolean;
  },
) => {
  const reduxActions = useAutomationActions();
  const list = useAutomationActionList(props);

  const onCloseClick = () => {
    reduxActions.hideActionsList();
  };

  const ref = useClickOutside<HTMLInputElement>(onCloseClick);

  return (
    <div className={classNames(css.container, props.className)} ref={ref}>
      <span className={css.close} onClick={onCloseClick}>
        <CloseOutlined />
      </span>
      <div className={css.header}>
        <PlusCircleFilled className={css.plusCircle} />
        <span className={css.title}>Actions</span>
      </div>

      <div className={css.list}>
        {Object.values(EAutomationActionCategory).map(c => {
          const listItems = list?.filter(a => a.category === c);
          if (!listItems.length) {
            return null;
          }
          return (
            <div key={c} className={css.category}>
              {c}
              <div className={css.actions}>
                {listItems.map(action => (
                  <div
                    key={action.name}
                    className={classNames(
                      css.item,
                      action?.className ? css[action.className] : '',
                      {
                        [css.disabled]: action.disabled,
                      },
                    )}
                    style={{ color: action.iconColor }}
                    onClick={async () => {
                      if (action.disabled) {
                        return;
                      }

                      const response = await action.add?.(
                        props.dialogueId,
                        props.sortOrder || 0,
                        props.pageGroupId,
                        props.widgetId,
                        props.position,
                      );

                      const widget = response as unknown as WidgetModel;

                      if (widget?.id) {
                        reduxActions.pushActionToOpen({
                          id: action.id,
                          widgetId: widget.id,
                        });
                      }

                      onCloseClick();
                    }}
                  >
                    <span className={css.icon}>
                      <action.icon color={action.iconColor} />
                    </span>

                    <span className={css.itemTitle}>
                      {action.category === EAutomationActionCategory.crm && (
                        <span>Send to </span>
                      )}
                      {action.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
